import React, { Component } from "react";
import dates from "../data/tour-dates";
import "../Styles/css/Tour.css";
import ticketIcon from "../assets/icon_ticket.svg";
import { Footer } from "../Components";

export default class Tour extends Component {

    render() {

        return (
            <div className="Tour">
                <h1>SHOWS</h1>
                <div className="shows-container">
                    {this.renderTourDates()}
                </div>
                <Footer />
            </div>
        );
    }

    renderTourDates() {

        const today = new Date();
        const upcomingDates = dates.filter(date => new Date(date.date) > today);

        if (!upcomingDates.length) {
            return (
                <div className="no-shows">
                    More shows to be announced!
                </div>
            );
        }

        return upcomingDates.map(date => this.renderDate(date));
    }

    renderDate(show) {

        const today = new Date();
        if (show.announced && new Date(show.announced) > today) {

            return null;

        }

        return (
            <div className="show-block" key={show.date}>
                <div className="left">
                    <div className="date">
                        <span className="month">
                            {show.month.substring(0, 3)}
                        </span>
                        <span className="day">{show.day}</span>
                    </div>
                    <div className="location">
                        <span className="venue">{show.venue}</span>
                        <span>{show.location}</span>
                    </div>
                </div>
                <div className="ticket">
                    <a
                        className="sparkle-container"
                        href={show.ticketURL}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <div className="sparkle" />
                        <img src={ticketIcon} alt="Ticket" />
                    </a>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/Containers/Tour.js